import { useMemo } from 'react'
import { useGameStore } from '@/store/gameStore'
import { useAchievementsStore } from '@/store/achievementsStore'
import { getClaimableGoals } from '@/ui/helpers/goals'

export interface ClaimableRewards {
  count: number
  /** First claimable goal in render order, for deep-linking straight to it */
  firstId: string | null
}

/**
 * Completed-but-unclaimed goal rewards (Metas) waiting in Carrera.
 * Achievements auto-claim, so the only "rewards to collect" are the goals.
 */
export function useClaimableRewards(): ClaimableRewards {
  const courts = useGameStore(s => s.courts)
  const reputation = useGameStore(s => s.reputation)
  const staff = useGameStore(s => s.staff)
  const transactions = useGameStore(s => s.transactions)
  const day = useGameStore(s => s.day)
  const claimedGoals = useGameStore(s => s.claimedGoals)
  const stats = useAchievementsStore(s => s.stats)

  return useMemo(() => {
    const claimable = getClaimableGoals(useGameStore.getState(), stats, claimedGoals)
    return { count: claimable.length, firstId: claimable[0]?.id ?? null }
  }, [courts, reputation, staff, transactions, day, claimedGoals, stats])
}
